import { Routes } from '@angular/router';
import { UserListComponent } from './features/users/user-list/user-list.component';
import { UserDetailComponent } from './features/users/user-detail/user-detail.component';
import { keycloakGuard } from './core/guard/auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { HistoriquesComponent } from './features/historiques/historiques.component';
import { ClientListComponent } from './features/clients/client-list/client-list.component';
import { UserCreateComponent } from './features/users/user-create/user-create.component';
import { AddClientComponent } from './features/clients/add-client/add-client.component';
import { EditClientComponent } from './features/clients/edit-client/edit-client.component';
import { ClientDetailsComponent } from './features/clients/client-details/client-details.component';
import { EditUserComponent } from './features/users/user-edit/user-edit.component';
import { JournalisationComponent } from './features/journalisation/journalisation.component';
import { UserRolesDialogComponent } from './features/roles/user-roles-dialog/user-roles-dialog.component';
import { GroupDetailsComponent } from './features/groups/group-details/group-details.component';
import { RoleListComponent } from './features/roles/role-list/role-list.component';
import { RoleFormComponent } from './features/roles/role-form/role-form.component';
import { RoleDetailComponent } from './features/roles/role-detail/role-detail.component';
import { AdminAuditComponent } from './features/admin-audit/admin-audit.component';
import { UserRole } from './core/services/permission.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    // Page d'accès refusé — accessible sans guard
    path: '.',
    loadComponent: () => import('./layout/access-denied/access-denied.component')
      .then(m => m.AccessDeniedComponent),
    title: 'Accès Refusé'
  },
  {
    path: 'dashboard',
    component: MainLayoutComponent,
    canActivate: [keycloakGuard],       // vérifie auth + rôle app.access
    canActivateChild: [keycloakGuard],
    children: [
      {
        path: 'users',
        component: UserListComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN, UserRole.SCA_IES_ADMIN] }
      },
      {
        path: 'users/add',
        component: UserCreateComponent,
        data: { requiredPermission: 'users.create' }
      },
      {
        path: 'users/:id/view',
        component: UserDetailComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN, UserRole.SCA_IES_ADMIN] }
      },
      {
        path: 'users/:id/edit',
        component: EditUserComponent,
        data: { requiredPermission: 'users.edit' }
      },
      {
        path: 'roles',
        component: RoleListComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },
      {
        path: 'roles/newRole',
        component: RoleFormComponent,
        data: { requiredPermission: 'roles.create' }
      },
      {
        path: 'roles/realm/:roleName/view',
        component: RoleDetailComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },
      {
        path: 'roles/realm/:roleName/edit',
        component: RoleFormComponent,
        data: { requiredPermission: 'roles.edit' }
      },
      {
        path: 'roles/client/:clientId/:roleName/view',
        component: RoleDetailComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },
      {
        path: 'roles/client/:clientId/:roleName/edit',
        component: RoleFormComponent,
        data: { requiredPermission: 'roles.edit' }
      },
      {
        path: 'roles/:id/habilitations-roles',
        component: UserRolesDialogComponent,
        data: { requiredPermission: 'users.manage_roles' }
      },
      {
        path: 'historiques',
        component: HistoriquesComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },
      {
        path: 'clients',
        component: ClientListComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },
      {
        path: 'clients/add',
        component: AddClientComponent,
        data: { requiredPermission: 'clients.create' }
      },
      {
        path: 'clients/:id/view',
        component: ClientDetailsComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },
      {
        path: 'clients/:id/edit',
        component: EditClientComponent,
        data: { requiredPermission: 'clients.edit' }
      },
      {
        path: 'journalisation',
        component: JournalisationComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },
      {
        path: 'admin-audit',
        component: AdminAuditComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN, UserRole.SCA_IES_ADMIN] }
      },
      {
        path: 'groups',
        loadComponent: () => import('./features/groups/group-list/group-list.component')
          .then(m => m.GroupListComponent),
        title: 'Gestion des Groupes',
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },
      {
        path: 'groups/:id/view',
        component: GroupDetailsComponent,
        data: { requiredRoles: [UserRole.SCA_SUPER_ADMIN] }
      },

      { path: '', redirectTo: 'users', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: 'dashboard' },
  // ...LIB_ROUTES,
];